import React from "react";

export default function BackupImageSettingsHeader({
  homeButtonSrc,
  bannerSubtitle,
  onNavigateHome,
}) {
  return (
    <>
      <div className="backup-image-settings-header">
        <div className="backup-image-settings-header-left">
          <img
            src={homeButtonSrc}
            alt="Back to home"
            className="backup-image-settings-home"
            onClick={onNavigateHome}
          />
          <div className="backup-image-settings-heading-group">
            <div className="backup-image-settings-breadcrumb">
              Backup Image Setting
            </div>
            <div className="backup-image-settings-subtitle">{bannerSubtitle}</div>
          </div>
        </div>
      </div>

      <div className="backup-image-settings-title">Backup Image Settings</div>
    </>
  );
}
